import { formatCurrency, pn, Skeleton, Typography } from "@compass/core";
import { HomeMatchDashboardRow } from "generated/openApi";

import { DevExpressReport } from "components";
import { Column } from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const DashboardTable = (props: { rows: HomeMatchDashboardRow[] | undefined; loading: boolean }) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  return props.loading ? (
    <Skeleton variant="rounded" height={500} />
  ) : (
    <DevExpressReport
      dashboardStyle
      dataSource={props.rows}
      fullPageSize
      showColumnChooser={false}
    >
      <Column
        dataField={pn<HomeMatchDashboardRow>("label")}
        caption="Category"
        allowSorting={false}
        cellRender={(data) => <Typography fontWeight={data.data.isBold ? "bold" : ""}>{data.text}</Typography>}
      />
      <Column
        dataField={pn<HomeMatchDashboardRow>("amount")}
        allowSorting={false}
        cellRender={(data) => (
          <Typography fontWeight={data.data.isBold ? "bold" : ""}>{formatCurrency(Number(data.text))}</Typography>
        )}
      />
    </DevExpressReport>
  );
};
